import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as Constants from '../../constants';
import { getInDomain } from '../../domains/externalUtils';

import BackstageInfiniteList from './BackstageInfiniteList';

const CLASS_NAME = 'BackstageItemList';
const INFINITE_SCROLL_THRESHOLD = 30;

class BackstageItemList extends React.Component {
  static propTypes = {
    sourceItems: ImmutablePropTypes.listOf(PropTypes.string),
    elementHeight: PropTypes.number.isRequired,
    generateListItemProps: PropTypes.func.isRequired,
    annotateObjectsForBackstage: PropTypes.func.isRequired,
    listItemComponent: PropTypes.node.isRequired,
    numPlaceholders: PropTypes.number,
  };

  static defaultProps = {
    generateListItemProps() {
      return {};
    },
  };

  componentDidMount() {
    this.makeApiCall(this.props.sourceItems);
  }

  /**
   * Makes API call for data, filters out  potential invalid pandoraIds
   *
   * @param {List} pandoraIds - list of pandoraId candidates
   */
  makeApiCall = pandoraIds => {
    if (pandoraIds) {
      const list = pandoraIds.filter(pandoraIdCandidate => {
        return !!pandoraIdCandidate;
      });

      if (list.size > 0) {
        this.props.annotateObjectsForBackstage(list);
      }
    }
  };

  generateListItemProps = (pandoraId, index) => {
    return {
      key: `${pandoraId}-${index}`,
      pandoraId,
      ...this.props.generateListItemProps(pandoraId, index),
    };
  };

  renderInfiniteList = () => {
    const ListItemComponent = this.props.listItemComponent;
    const props = {
      listItemProps: this.props.sourceItems.map(this.generateListItemProps),
      apiCall: this.makeApiCall,
      listItemComponent: ListItemComponent,
      className: CLASS_NAME,
      elementHeight: this.props.elementHeight,
      infiniteLoadBeginEdgeOffset: 200,
      mapListItemPropsToApiCallParams(propsToRender) {
        return propsToRender.map(itemProps => itemProps.pandoraId);
      },
    };

    return <BackstageInfiniteList {...props} />;
  };

  renderListItem = (pandoraId, index) => {
    const props = this.generateListItemProps(pandoraId, index);
    const ListItemComponent = this.props.listItemComponent;
    return <ListItemComponent {...props} />;
  };

  renderItemList = () => {
    const { sourceItems, numPlaceholders } = this.props;
    const sourceItemList =
      sourceItems && sourceItems.size > 0 ? sourceItems : List().setSize(numPlaceholders);

    return (
      <div className={CLASS_NAME} data-qa={Constants.QATags.BST}>
        {sourceItemList.map(this.renderListItem)}
      </div>
    );
  };

  render() {
    const useInfiniteScroll =
      this.props.sourceItems && this.props.sourceItems.size > INFINITE_SCROLL_THRESHOLD;
    return useInfiniteScroll ? this.renderInfiniteList() : this.renderItemList();
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      annotateObjectsForBackstage: getInDomain('backstage.actions.annotateObjectsForBackstage'),
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(BackstageItemList);
